import * as React from "react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { cn } from "../../lib/utils";

const Input = React.forwardRef(({ className, type, onChange, value, min, max, ...props }, ref) => {
  if (type === "date") {
    let selectedDate = null;
    if (value) {
      const parsedDate = new Date(value);
      if (!isNaN(parsedDate.getTime())) {
        selectedDate = parsedDate;
      }
    }

    let minDate = undefined;
    if (min) {
      const parsedMin = new Date(min);
      if (!isNaN(parsedMin.getTime())) {
        minDate = parsedMin;
      }
    }

    let maxDate = undefined;
    if (max) {
      const parsedMax = new Date(max);
      if (!isNaN(parsedMax.getTime())) {
        maxDate = parsedMax;
      }
    }

    const handleChange = (date) => {
      if (onChange) {
        let formattedValue = "";
        if (date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          formattedValue = `${year}-${month}-${day}`;
        }
        onChange({
          target: {
            id: props.id,
            name: props.name,
            value: formattedValue
          }
        });
      }
    };

    return (
      <DatePicker
        selected={selectedDate}
        onChange={handleChange}
        minDate={minDate}
        maxDate={maxDate}
        dateFormat="dd/MM/yyyy"
        placeholderText={props.placeholder || "dd/mm/yyyy"}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-yale-blue-950 dark:text-slate-100 dark:border-yale-blue-800 dark:focus-visible:ring-ring",
          className
        )}
        wrapperClassName="w-full"
        disabled={props.disabled}
        required={props.required}
        autoComplete="off"
        ref={ref}
        {...props}
      />
    );
  }

  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-yale-blue-950 dark:text-slate-100 dark:border-yale-blue-800 dark:focus-visible:ring-ring",
        className
      )}
      ref={ref}
      onChange={onChange}
      value={value}
      min={min}
      max={max}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
